<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right">
      <el-form-item label="资讯标题" prop="publishTitle">
        <el-input
          v-model="search.publishTitle"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="发布日期" prop="publishDate">
        <el-date-picker
          v-model="publishDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="操作时间" prop="operationTime">
        <el-date-picker
          v-model="operationTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="操作人" prop="publishBy">
        <el-input
          v-model="search.publishBy"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="置顶" prop="topFlag">
        <el-select v-model="search.topFlag" placeholder="请选择" clearable>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-row class="row">
      <el-col :span="8">
        <el-button type="primary" size="medium" @click="handleSearch()"
          >查询</el-button
        >
        <el-button size="medium" @click="resetForm">重置</el-button>

        <el-button type="primary" size="medium" @click="openModal('add')"
          >+ 添加资讯</el-button
        >
      </el-col>
    </el-row>
    <el-table :data="list" center height="60vh">
      <el-table-column label="资讯封面" prop="publishFileId" width="150">
        <template slot-scope="scope">
          <!-- <el-image
            style="width: 80px; height: 80px; margin-right: 20px"
            fit="cover"
            :src="scope.row.publishFileId"
          ></el-image> -->
          <image-upload
            v-if="scope.row.publishFileId"
            :imageUrl.sync="scope.row.publishFileId"
            :editMode="false"
          />
        </template>
      </el-table-column>
      <el-table-column label="资讯标题" prop="publishTitle"></el-table-column>
      <el-table-column
        label="发布日期"
        prop="publishDate"
        width="180"
      ></el-table-column>
      <el-table-column
        label="操作时间"
        prop="lastModifiedDate"
        width="180"
      ></el-table-column>
      <el-table-column
        label="操作人"
        prop="publishBy"
        width="120"
      ></el-table-column>
      <el-table-column label="置顶" prop="topFlag" width="80">
        <template slot-scope="scope">
          {{ scope.row.topFlag === 1 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <!-- <el-button type="text" @click="goDetail(scope.row)">查看</el-button> -->
          <el-button type="text" @click="del(scope.row.id)">删除</el-button>
          <el-button type="text" @click="openModal('edit', scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.size"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <addInfoModal ref="addInfoModalRef" @opera-success="getList"></addInfoModal>
  </div>
</template>

<script>
import addInfoModal from "./components/addInfoModal";
import imageUpload from "@/components/Upload/ImageUpload";
import { delPublish, getPublishList } from "@/api/mpManagement";
export default {
  name: "information",
  components: { addInfoModal, imageUpload },

  data() {
    return {
      inventoryItems: [
        { label: "新项1", value: "--", unit: "单位" },
        { label: "新项2", value: "--", unit: "单位" },
      ],
      list: [],
      total: 0,
      publishDate: [],
      operationTime: [],
      search: {
        page: 1, // 页码
        size: 10, // 每页大小
        publishTitle: "", // 资讯标题
        publishBy: "", // 发布人
        topFlag: "", // 置顶标志
        startPublishDate: "", // 开始发布日期
        endPublishDate: "", // 结束发布日期
        startOpeartionDate: "", // 开始操作日期
        endOpeartionDate: "", // 结束操作日期
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.search.page = 1;
      this.search.size = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    handleSearch() {
      this.search.page = 1;
      this.getList();
    },
    resetForm() {
      this.search = this.$options.data().search;
      this.publishDate = this.operationTime = [];
    },
    async getList() {
      if (this.publishDate.length === 2) {
        this.search.startPublishDate = this.publishDate[0];
        this.search.endPublishDate = this.publishDate[1];
      } else {
        this.search.startPublishDate = "";
        this.search.endPublishDate = "";
      }

      if (this.operationTime.length === 2) {
        this.search.startOpeartionDate = this.operationTime[0];
        this.search.endOpeartionDate = this.operationTime[1];
      } else {
        this.search.startOpeartionDate = "";
        this.search.endOpeartionDate = "";
      }

      let { statusCode, data, total, message } = await getPublishList(
        this.search
      );
      if (statusCode == 200) {
        this.list = data;
        this.total = total;
      } else {
        this.list = [];
        this.total = 0;
        this.$message.error(message);
      }
    },
    openModal(flag, rowData) {
      this.$refs.addInfoModalRef.openDialog(flag, rowData);
    },
    async del(id) {
      await this.$confirm("确认删除该资讯?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      });

      let { statusCode, data } = await delPublish(id);
      if (statusCode != 200) {
        return;
      }
      this.$message.success("删除成功");

      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/mpManagement/information.vue